import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Page, PageHeader } from "@/components/Bits";
import { PracticeTab, BrandingTab } from "@/pages/Settings";
import { TeamUsersPanel } from "@/pages/Users";

export default function PracticeSettings() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();

  const tabs = [
    { id: "practice", label: "Practice Details" },
    { id: "branding", label: "Branding" },
    { id: "team", label: "Team & Users" },
  ];
  const requested = params.get("tab");
  const [tab, setTab] = useState(tabs.some((t) => t.id === requested) ? requested : "practice");

  const selectTab = (id) => {
    setTab(id);
    const next = new URLSearchParams(params);
    next.set("tab", id);
    setParams(next, { replace: true });
  };

  if (user && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  return (
    <Page>
      <PageHeader overline="Your practice" title="Practice Settings"
        subtitle="Your firm's details, branding and team — shared across every connected organisation." />

      <div className="flex items-center gap-1 mb-7 bg-slate-100 p-1 rounded-xl w-fit max-w-full overflow-x-auto">
        {tabs.map((t) => (
          <button key={t.id} onClick={() => selectTab(t.id)} data-testid={`practice-tab-${t.id}`}
            className={`px-4 py-2 text-sm font-medium rounded-lg whitespace-nowrap transition-all duration-150 ${
              tab === t.id ? "bg-white text-navy shadow-card" : "text-slate-600 hover:text-navy"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "practice" && <PracticeTab />}
      {tab === "branding" && <BrandingTab />}
      {tab === "team" && <TeamUsersPanel />}
    </Page>
  );
}
